import { useEffect, useRef } from 'react'

const usePortal = (id = 'loader-root') => {
  const portalElemRef = useRef(document.createElement('div'))

  useEffect(() => {
    const parentElem = document.getElementById(id)
    const currentElement = portalElemRef.current

    if (parentElem) {
      parentElem.appendChild(currentElement)
    }

    return () => {
      currentElement.remove()
    }
  }, [id])

  return portalElemRef.current
}

export default usePortal
